/**
 * Automatically adds the "in stock" filter to all collection links.
 * This ensures that when customers click on collection links, they only see available products.
 */
(function() {
  const AVAILABILITY_PARAM = 'filter.v.availability';
  const AVAILABILITY_VALUE = '1';

  /**
   * Checks if a URL is a collection URL
   * @param {string} href - The URL to check
   * @returns {boolean}
   */
  function isCollectionUrl(href) {
    if (!href) return false;
    try {
      const url = new URL(href, window.location.origin);
      return url.pathname.startsWith('/collections/');
    } catch {
      return false;
    }
  }

  /**
   * Adds availability filter to a URL if not already present
   * @param {string} href - The original URL
   * @returns {string} - The URL with availability filter
   */
  function addAvailabilityFilter(href) {
    try {
      const url = new URL(href, window.location.origin);

      // Don't add if already has availability filter
      if (url.searchParams.has(AVAILABILITY_PARAM)) {
        return href;
      }

      url.searchParams.set(AVAILABILITY_PARAM, AVAILABILITY_VALUE);
      return url.toString();
    } catch {
      return href;
    }
  }

  /**
   * Processes a single link element
   * @param {HTMLAnchorElement} link
   */
  function processLink(link) {
    const href = link.getAttribute('href');
    if (isCollectionUrl(href)) {
      link.setAttribute('href', addAvailabilityFilter(href));
    }
  }

  /**
   * Processes all collection links on the page
   */
  function processAllLinks() {
    document.querySelectorAll('a[href*="/collections/"]').forEach(processLink);
  }

  // Process links when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAllLinks);
  } else {
    processAllLinks();
  }

  // Observe for dynamically added links (e.g., mega menu, AJAX content)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Check if the added node itself is a collection link
          if (node.tagName === 'A' && isCollectionUrl(node.getAttribute('href'))) {
            processLink(node);
          }
          // Check for collection links within the added node
          node.querySelectorAll?.('a[href*="/collections/"]').forEach(processLink);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
